import { render } from "./ContactThanks.vue?vue&type=template&id=f78997ce"
import script from "./ContactThanks.vue?vue&type=script&lang=js"
export * from "./ContactThanks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__